import {Cross} from './Icons';
import React from 'react';
import styled from 'styled-components';

const StyledCloseBtn = styled.button`
 position: absolute;
 background-color: transparent;
 border: none;
 width: 30px;
 height: 30px;
 padding: 4px;
 top: 50%;
 right: 0;
 margin-top: -15px;
 cursor: pointer;
 
 svg path {
  fill: #fff;
 }
`

const AlertClose = ({onClick}) => {
    return  <StyledCloseBtn onClick={onClick} id='continue-button'>{Cross}</StyledCloseBtn>
};

export default AlertClose;